import React, { useState, useEffect } from 'react';
import ClipLoader from "react-spinners/ClipLoader";
import Comm from '../comm/comm';
import Tools from '../tools/tools';
import { toast } from 'react-toastify';
import ModalUpload from '../controls/ModalUpload';
import { Link, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';


const RequestHistory = (props) => {
    let [jobs, setJobs] = useState();
    const requestId = sessionStorage.getItem("requestId");


    const fetchData = async () => {
        if (!requestId) {
            return;
        }

        setJobs(null);
        Comm.Instance().get(`job?requestId=${requestId}`).then(result => {
            setJobs(result.data);

        }).catch(error => Tools.ProcessError(error))
    };
    useEffect(() => {

        fetchData();
    }, []);

    if (!requestId) {
        return (<Redirect to="/MyJobs" />);
    }


    if (!jobs)
        return (
            <div className="container">
                <ClipLoader
                    size={150}
                    color={"#123abc"}
                    loading={!jobs}
                />
            </div>
        );
    return (
        <div className="container">
            
            <div className="form-row">
                <div className="form-group col-md-12">
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th>
                                    Дейност
                                    </th>
                                <th>
                                    От дата
                                    </th>
                                <th>
                                    Текущ статус
                                    </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                jobs.map(i =>
                                    <tr key={i.jobId}>
                                        <td>
                                            <Link to={'/RequestJob/' + i.jobId}>{i.name}</Link>
                                        </td>
                                        <td>
                                            {Tools.FormatDate(i.createdOn)}
                                        </td>
                                        <td>
                                            {i.jobStateTitle}
                                        </td>

                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

    );
}


export default RequestHistory;

